import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

interface FullScreenLoaderProps {
  open: boolean;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ open }) => {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default FullScreenLoader;